/* Feel Awsm — Darm Balance Funnel JS (Shopify Asset)
   All DOM queries scoped to .darm-funnel wrapper
   Variant ID: 55749583798596
   Selling Plan ID: 692908917060
*/

document.addEventListener('DOMContentLoaded', function() {
  var funnel = document.querySelector('.darm-funnel');
  if (!funnel) return;

  /* ═══════════════════════════════════════════
     SHOPIFY AJAX ADD TO CART (cart-drawer pattern)
     Mirrors assets/feelawsm-electrolyte-funnel.js
  ═══════════════════════════════════════════ */

  var addingLabel = 'Adding\u2026';

  function getCartUi() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function getCartAddUrl() {
    var cartAddPath =
      typeof routes !== 'undefined' && routes.cart_add_url
        ? String(routes.cart_add_url)
        : '/cart/add';
    if (cartAddPath.startsWith('/') && cartAddPath.indexOf('cart') !== -1) {
      return cartAddPath.replace(/\/cart\/add\/?$/, '/cart/add.js');
    }
    return '/cart/add.js';
  }

  function parseQuantity(btn) {
    var q = parseInt(btn.getAttribute('data-quantity'), 10);
    if (!Number.isNaN(q) && q > 0) return q;
    return 1;
  }

  function fetchSectionHtmlForCart(cart, data, doRender) {
    if (data.sections || !cart || typeof routes === 'undefined' || !routes.cart_url) {
      doRender(data);
      return Promise.resolve();
    }
    var sectionIds = cart.getSectionsToRender().map(function (s) { return s.id; });
    return Promise.all(
      sectionIds.map(function (id) {
        return fetch(routes.cart_url + '?section_id=' + id, { cache: 'no-store' }).then(function (r) {
          return r.text();
        });
      })
    )
    .then(function (htmls) {
      var sections = {};
      sectionIds.forEach(function (id, i) { sections[id] = htmls[i]; });
      doRender(Object.assign({}, data, { sections: sections }));
    })
    .catch(function () { doRender(data); });
  }

  funnel.querySelectorAll('.js-feelawsm-funnel-atc').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-disabled') === 'true') return;

      var cart = getCartUi();
      var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
      var spRaw = btn.getAttribute('data-selling-plan') || '';
      var quantity = parseQuantity(btn);

      if (!vid || Number.isNaN(vid)) { alert('Missing variant'); return; }

      var sellingPlanId = null;
      if (String(spRaw).trim() !== '') {
        var spNum = parseInt(spRaw, 10);
        if (!Number.isNaN(spNum)) sellingPlanId = spNum;
      }

      var item = { id: vid, quantity: quantity };
      if (sellingPlanId != null) item.selling_plan = sellingPlanId;

      var body = { items: [item] };
      if (cart) {
        cart.setActiveElement(document.activeElement);
        if (sellingPlanId == null) {
          body.sections = cart.getSectionsToRender().map(function (section) { return section.id; });
          body.sections_url = window.location.pathname;
        }
      }

      var addUrl = getCartAddUrl();
      var bodyString = JSON.stringify(body);

      var previousHtml = btn.innerHTML;
      btn.innerHTML = '';
      btn.appendChild(document.createTextNode(addingLabel));
      btn.classList.add('feelawsm-funnel-atc--loading');
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('aria-disabled', 'true');

      var cartAddPromise =
        sellingPlanId != null
          ? new Promise(function (resolve, reject) {
              var xhr = new XMLHttpRequest();
              xhr.open('POST', addUrl, true);
              xhr.setRequestHeader('Content-Type', 'application/json');
              xhr.setRequestHeader('Accept', 'application/json');
              xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
              xhr.onload = function () {
                if (xhr.status < 200 || xhr.status >= 400) {
                  reject(new Error('Cart add failed: ' + xhr.status));
                  return;
                }
                try { resolve(JSON.parse(xhr.responseText)); }
                catch (e) { reject(e); }
              };
              xhr.onerror = function () { reject(new Error('Cart add network error')); };
              xhr.send(bodyString);
            })
          : fetch(addUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: bodyString,
            }).then(function (response) {
              if (!response.ok) throw new Error('Cart add failed: ' + response.status);
              return response.json();
            });

      cartAddPromise
        .then(function (response) {
          if (response.status) {
            if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
              publish(window.PUB_SUB_EVENTS.cartError, {
                source: 'feelawsm-darm-balance-funnel',
                productVariantId: String(vid),
                errors: response.errors || response.description,
                message: response.message,
              });
            }
            var desc = (response.description || response.message || 'Could not add to cart').toString();
            alert(desc);
            return;
          }

          if (!cart) {
            if (typeof routes !== 'undefined' && routes.cart_url) {
              window.location.href = routes.cart_url;
            } else {
              window.location.href = '/cart';
            }
            return;
          }

          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'feelawsm-darm-balance-funnel',
              productVariantId: String(vid),
              cartData: response,
            });
          }
          window.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

          var doRender = function (data) { cart.renderContents(data); };

          if (cart.classList && cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
          }

          return fetchSectionHtmlForCart(cart, response, doRender);
        })
        .catch(function (err) {
          console.warn('[feelawsm-darm-funnel]', err);
          var msg = (err && err.message) || 'Could not add to cart';
          alert(msg);
        })
        .finally(function () {
          btn.innerHTML = previousHtml;
          btn.classList.remove('feelawsm-funnel-atc--loading');
          btn.removeAttribute('aria-busy');
          btn.removeAttribute('aria-disabled');
        });
    });
  });

  /* ═══════════════════════════════════════════
     CAPSULE JOURNEY CANVAS ANIMATION
  ═══════════════════════════════════════════ */

  (function(){
    var cv = document.getElementById('journeyCanvas');
    if (!cv) return;
    var ctx = cv.getContext('2d');
    var W = 760, H = 500;
    var mode = 'bad';
    var step = 0;
    var playing = false;
    var playTimer = null;
    var animT = 0;
    var capsuleProg = 0;
    var rafId = null;

    var STAGES = {
      bad: [
        { icon:'\uD83D\uDC8A', title:'You swallow the capsule', desc:'A normal probiotic capsule. Looks fine. But the problem starts the moment it hits your stomach.', pill:'Step 1 of 4' },
        { icon:'\u26A0\uFE0F', title:'Your stomach is very acidic', desc:'Your stomach acid is strong. Most capsules weren\'t built for this. They start breaking apart right here.', pill:'This is where it goes wrong' },
        { icon:'\uD83D\uDC80', title:'Capsule breaks apart. Bacteria die.', desc:'The capsule opens too early. Acid kills most of the bacteria. They never make it to your gut.', pill:'9 out of 10 bacteria lost' },
        { icon:'\u274C', title:'Nothing arrives. Nothing changes.', desc:'You paid. You swallowed every day. But the bacteria died before doing anything. That\'s why you felt nothing.', pill:'Zero effect \u00B7 Wasted money' },
      ],
      good: [
        { icon:'\uD83D\uDC8A', title:'You swallow Gut Balance', desc:'A protected capsule. 35 billion live bacteria inside \u2014 sealed tight and ready for the trip through your stomach.', pill:'Step 1 of 4' },
        { icon:'\uD83D\uDEE1\uFE0F', title:'Stays sealed through your stomach', desc:'The shell is built to resist stomach acid. It doesn\'t open here. Every bacterium stays alive and protected.', pill:'All bacteria safe' },
        { icon:'\uD83C\uDFAF', title:'Opens in your gut \u2014 right where it counts', desc:'Once it reaches your gut, the shell naturally opens. All 35 billion bacteria released exactly where they need to be.', pill:'Delivered where it works' },
        { icon:'\u2728', title:'Bacteria settle in and get to work', desc:'Live bacteria set up home in your gut. Less bloating. Better digestion. Vaginal balance. Stronger immune system. This is what actually working feels like.', pill:'35 Billion live \u00B7 Full effect' },
      ]
    };

    var PATH = [
      {x:380, y:76}, {x:376, y:155}, {x:366, y:218},
      {x:344, y:268}, {x:330, y:322}, {x:346, y:385}, {x:352, y:430}
    ];

    function lerp(a,b,t){ return a+(b-a)*t; }
    function getPos(prog){
      var n = PATH.length-1;
      var s = Math.min(prog*n, n-0.001);
      var i = Math.floor(s);
      var t = s-i;
      return { x: lerp(PATH[i].x, PATH[i+1].x, t), y: lerp(PATH[i].y, PATH[i+1].y, t) };
    }
    var STEP_PROG = [0, 0.22, 0.50, 0.82];

    function drawBG(){
      ctx.clearRect(0,0,W,H);
      var grad = ctx.createLinearGradient(0,0,0,H);
      grad.addColorStop(0,'#F7F3FD'); grad.addColorStop(1,'#FEFCFA');
      ctx.fillStyle = grad; ctx.fillRect(0,0,W,H);
    }

    function drawSilhouette(){
      var cx = 380;
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(cx-75,132);
      ctx.bezierCurveTo(cx-95,165,cx-95,240,cx-88,310);
      ctx.bezierCurveTo(cx-82,375,cx-74,430,cx-70,470);
      ctx.lineTo(cx+70,470);
      ctx.bezierCurveTo(cx+74,430,cx+82,375,cx+88,310);
      ctx.bezierCurveTo(cx+95,240,cx+95,165,cx+75,132);
      ctx.closePath();
      ctx.fillStyle='#F5E6D8'; ctx.fill();
      ctx.strokeStyle='#D9B89A'; ctx.lineWidth=1; ctx.stroke();
      ctx.beginPath(); ctx.ellipse(cx,62,42,50,0,0,Math.PI*2);
      ctx.fillStyle='#F0D5C0'; ctx.fill();
      ctx.strokeStyle='#C4A882'; ctx.lineWidth=1; ctx.stroke();
      ctx.beginPath(); ctx.ellipse(cx,42,44,26,0,0,Math.PI*2);
      ctx.fillStyle='#4A2C1A'; ctx.fill();
      ctx.beginPath(); ctx.ellipse(cx-30,70,14,28,-0.15,0,Math.PI*2);
      ctx.fillStyle='#4A2C1A'; ctx.fill();
      ctx.beginPath(); ctx.ellipse(cx+30,70,14,28,0.15,0,Math.PI*2);
      ctx.fillStyle='#4A2C1A'; ctx.fill();
      ctx.beginPath();
      ctx.moveTo(cx-10,108); ctx.lineTo(cx+10,108);
      ctx.lineTo(cx+11,136); ctx.lineTo(cx-11,136);
      ctx.closePath(); ctx.fillStyle='#F0D5C0'; ctx.fill();
      [[-1,1],[1,-1]].forEach(function(pair){
        var dx=pair[0];
        ctx.beginPath(); ctx.moveTo(cx+dx*75,148);
        ctx.bezierCurveTo(cx+dx*108,188,cx+dx*118,260,cx+dx*112,360);
        ctx.lineWidth=26; ctx.strokeStyle='#F0D5C0'; ctx.lineCap='round'; ctx.stroke();
        ctx.lineWidth=1; ctx.strokeStyle='#C4A882'; ctx.stroke();
      });
      ctx.beginPath();
      ctx.moveTo(cx-75,310); ctx.lineTo(cx-70,470); ctx.lineTo(cx+70,470); ctx.lineTo(cx+75,310);
      ctx.quadraticCurveTo(cx,295,cx-75,310);
      ctx.fillStyle='rgba(91,45,142,0.12)'; ctx.fill();
      [[cx-24,470,22],[cx+24,470,22]].forEach(function(arr){
        var lx=arr[0],ly=arr[1],r=arr[2];
        ctx.beginPath();
        ctx.moveTo(lx-r,ly); ctx.lineTo(lx-r,ly+100);
        ctx.quadraticCurveTo(lx,ly+116,lx+r,ly+100); ctx.lineTo(lx+r,ly);
        ctx.fillStyle='#E8D5C4'; ctx.fill();
        ctx.strokeStyle='#C4A882'; ctx.lineWidth=0.8; ctx.stroke();
      });
      [[cx-24,568],[cx+24,568]].forEach(function(arr){
        ctx.beginPath(); ctx.ellipse(arr[0],arr[1],30,10,0,0,Math.PI*2);
        ctx.fillStyle='#3A2010'; ctx.fill();
      });
      ctx.restore();
    }

    function drawOrgans(){
      var cx = 380;
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(cx,112); ctx.lineTo(cx-2,160); ctx.lineTo(cx-4,218);
      ctx.lineWidth=10; ctx.strokeStyle='#DEB8A0'; ctx.lineCap='round'; ctx.stroke();
      ctx.lineWidth=1.5; ctx.strokeStyle='#C4927A'; ctx.stroke();
      var stomachAlert = mode==='bad' && step>=1 && step<=2;
      ctx.beginPath(); ctx.moveTo(cx-16,222);
      ctx.bezierCurveTo(cx-42,226,cx-56,244,cx-58,266);
      ctx.bezierCurveTo(cx-60,290,cx-52,314,cx-32,324);
      ctx.bezierCurveTo(cx-14,334,cx+12,332,cx+24,320);
      ctx.bezierCurveTo(cx+38,306,cx+40,286,cx+32,264);
      ctx.bezierCurveTo(cx+24,242,cx+8,224,cx-4,220);
      ctx.closePath();
      ctx.fillStyle = stomachAlert ? '#FFCDD2' : '#F4C5A8'; ctx.fill();
      ctx.strokeStyle = stomachAlert ? '#E53935' : '#D4956E';
      ctx.lineWidth = stomachAlert ? 2 : 1.5; ctx.stroke();
      ctx.font = stomachAlert ? 'bold 13px DM Sans,sans-serif' : '11px DM Sans,sans-serif';
      ctx.fillStyle = stomachAlert ? '#B71C1C' : '#8B4513';
      ctx.textAlign='center'; ctx.fillText('pH 1\u20132', cx-14, 272);
      if(stomachAlert){ ctx.font='10px DM Sans,sans-serif'; ctx.fillText('DANGER ZONE', cx-14, 287); }
      var gutGlow = mode==='good' && step>=2;
      ctx.beginPath(); ctx.moveTo(cx+24,320);
      ctx.bezierCurveTo(cx+48,330,cx+56,352,cx+46,374);
      ctx.bezierCurveTo(cx+36,396,cx+12,404,cx-8,398);
      ctx.bezierCurveTo(cx-32,392,cx-44,372,cx-36,352);
      ctx.bezierCurveTo(cx-28,334,cx-10,326,cx+6,328);
      ctx.lineWidth=13; ctx.strokeStyle = gutGlow ? '#7BC88A' : '#F0B090';
      ctx.lineCap='round'; ctx.stroke();
      ctx.lineWidth=1.5; ctx.strokeStyle = gutGlow ? '#1A6B3C' : '#D4956E'; ctx.stroke();
      if(gutGlow){
        ctx.font='10px DM Sans,sans-serif'; ctx.fillStyle='#1A6B3C';
        ctx.textAlign='center'; ctx.fillText('colonization zone', cx+8, 410);
      }
      ctx.beginPath(); ctx.moveTo(cx-36,398);
      ctx.bezierCurveTo(cx-54,412,cx-60,436,cx-54,456);
      ctx.bezierCurveTo(cx-48,474,cx-24,480,cx-4,478);
      ctx.bezierCurveTo(cx+20,476,cx+38,460,cx+40,438);
      ctx.bezierCurveTo(cx+42,416,cx+30,400,cx+12,392);
      ctx.lineWidth=14; ctx.strokeStyle='#E8C4A8'; ctx.lineCap='round'; ctx.stroke();
      ctx.lineWidth=1.5; ctx.strokeStyle='#C4927A'; ctx.stroke();
      ctx.restore();
    }

    function drawTrail(){
      if(capsuleProg < 0.01) return;
      var color = mode==='bad' ? '#E53935' : '#1A6B3C';
      for(var i=0;i<PATH.length-1;i++){
        var segS = i/(PATH.length-1), segE = (i+1)/(PATH.length-1);
        var p = Math.min(Math.max((capsuleProg-segS)/(segE-segS),0),1);
        if(p<=0) break;
        var a = PATH[i], b = PATH[i+1];
        ctx.beginPath(); ctx.moveTo(a.x,a.y);
        ctx.lineTo(lerp(a.x,b.x,p), lerp(a.y,b.y,p));
        ctx.lineWidth=2.5; ctx.strokeStyle=color; ctx.globalAlpha=0.22;
        ctx.setLineDash([6,5]); ctx.lineCap='round'; ctx.stroke();
        ctx.setLineDash([]); ctx.globalAlpha=1;
      }
    }

    function drawCapsule(x,y){
      ctx.save(); ctx.translate(x,y);
      var pulse = Math.sin(animT*4)*1.5;
      if(mode==='bad' && step>=2){
        var spikes=8, outer=20+Math.sin(animT*7)*3;
        ctx.beginPath();
        for(var i=0;i<spikes*2;i++){
          var a=(i/(spikes*2))*Math.PI*2-Math.PI/2;
          var r=i%2===0?outer:9;
          if(i===0) ctx.moveTo(Math.cos(a)*r, Math.sin(a)*r);
          else ctx.lineTo(Math.cos(a)*r, Math.sin(a)*r);
        }
        ctx.closePath(); ctx.fillStyle='#FFCDD2'; ctx.fill();
        ctx.strokeStyle='#E53935'; ctx.lineWidth=1.8; ctx.stroke();
        ctx.font='bold 15px sans-serif'; ctx.fillStyle='#B71C1C';
        ctx.textAlign='center'; ctx.textBaseline='middle'; ctx.fillText('\u2715',0,0);
        if(step>=3){
          for(var j=0;j<5;j++){
            var da=(animT*0.6+j*1.2)%(Math.PI*2);
            var dx=Math.cos(da)*8+j*6-20, dy=Math.sin(da)*4+j*18+28;
            ctx.globalAlpha=0.18+Math.sin(animT*2+j)*0.07;
            ctx.beginPath(); ctx.arc(dx,dy,3.5,0,Math.PI*2);
            ctx.fillStyle='#E53935'; ctx.fill(); ctx.globalAlpha=1;
          }
        }
      } else if(mode==='good' && step>=2){
        ctx.beginPath(); ctx.arc(0,0,22+pulse,0,Math.PI*2);
        ctx.strokeStyle='rgba(26,107,60,0.35)'; ctx.lineWidth=2.5;
        ctx.setLineDash([4,3]); ctx.stroke(); ctx.setLineDash([]);
        if(step>=3){
          for(var k=0;k<10;k++){
            var ag=(animT*1.2+k*(Math.PI*2/10));
            var rr=28+Math.sin(animT*4+k)*6;
            ctx.globalAlpha=0.12+Math.sin(animT*3+k*0.9)*0.12+0.15;
            ctx.beginPath(); ctx.arc(Math.cos(ag)*rr*0.55, Math.sin(ag)*rr*0.55, 3,0,Math.PI*2);
            ctx.fillStyle='#1A6B3C'; ctx.fill(); ctx.globalAlpha=1;
          }
          ctx.beginPath(); ctx.arc(0,0,15,0,Math.PI*2);
          ctx.fillStyle='rgba(26,107,60,0.18)'; ctx.fill();
          ctx.font='bold 16px sans-serif'; ctx.fillStyle='#1A6B3C';
          ctx.textAlign='center'; ctx.textBaseline='middle'; ctx.fillText('\u2713',0,0);
        } else {
          ctx.beginPath(); ctx.ellipse(6,0,13,8,0,0,Math.PI*2);
          ctx.fillStyle='#A8D8B0'; ctx.fill(); ctx.strokeStyle='#1A6B3C'; ctx.lineWidth=1.2; ctx.stroke();
          ctx.beginPath(); ctx.ellipse(-6,0,8,8,0,0,Math.PI*2);
          ctx.fillStyle='#1A6B3C'; ctx.fill(); ctx.strokeStyle='#1A6B3C'; ctx.lineWidth=1; ctx.stroke();
        }
      } else {
        var bc = mode==='bad'?'#F48080':'#A8D8B0';
        var cc = mode==='bad'?'#E53935':'#1A6B3C';
        ctx.beginPath(); ctx.ellipse(6,0,13,8,0,0,Math.PI*2);
        ctx.fillStyle=bc; ctx.fill(); ctx.strokeStyle=cc; ctx.lineWidth=1.2; ctx.stroke();
        ctx.beginPath(); ctx.ellipse(-6,0,8,8,0,0,Math.PI*2);
        ctx.fillStyle=cc; ctx.fill(); ctx.strokeStyle=cc; ctx.lineWidth=1; ctx.stroke();
        if(mode==='good'){
          ctx.font='10px sans-serif'; ctx.textAlign='center'; ctx.textBaseline='middle';
          ctx.fillText('\uD83D\uDEE1',6,-14);
        }
      }
      ctx.restore();
    }

    function drawUI(){
      var label = document.getElementById('floatLabel');
      if(label){
        label.textContent = 'Step '+(step+1)+' of 4';
        label.style.color = mode==='bad'?'#9B1C1C':'#14532D';
        label.style.borderColor = mode==='bad'?'#FECACA':'#BBF7D0';
        label.style.background = mode==='bad'?'rgba(254,242,242,0.96)':'rgba(240,253,244,0.96)';
      }
    }

    function render(){
      animT += 0.025;
      var targetP = STEP_PROG[Math.min(step,3)];
      capsuleProg += (targetP - capsuleProg) * 0.055;
      drawBG(); drawSilhouette(); drawOrgans(); drawTrail();
      var pos = getPos(capsuleProg);
      drawCapsule(pos.x, pos.y); drawUI();
      rafId = requestAnimationFrame(render);
    }

    function updateInfoPanel(){
      var s = STAGES[mode][step];
      var isBad = mode==='bad';
      var col = isBad?'#C0392B':'#1A6B3C';
      var bg  = isBad?'#FEF2F2':'#F0FDF4';
      var pbg = isBad?'#FEE2E2':'#DCFCE7';
      var ptx = isBad?'#9B1C1C':'#14532D';
      document.getElementById('jIcon').textContent=s.icon;
      document.getElementById('jIcon').style.background=bg;
      document.getElementById('jTitle').textContent=s.title;
      document.getElementById('jTitle').style.color=col;
      document.getElementById('jDesc').textContent=s.desc;
      document.getElementById('jPill').textContent=s.pill;
      document.getElementById('jPill').style.background=pbg;
      document.getElementById('jPill').style.color=ptx;
      var dotsEl = document.getElementById('journeyDots');
      dotsEl.innerHTML='';
      for(var i=0;i<4;i++){
        var d=document.createElement('div');
        var isActive = i===step;
        d.style.cssText='width:'+(isActive?10:7)+'px;height:'+(isActive?10:7)+'px;border-radius:50%;cursor:pointer;transition:all .2s;background:'+(isActive?(isBad?'#C0392B':'#1A6B3C'):'#E0D4F5')+';';
        d.onclick=(function(si){ return function(){ step=si; updateInfoPanel(); }; })(i);
        dotsEl.appendChild(d);
      }
      var pb = document.getElementById('journeyPlay');
      pb.textContent = playing ? '\u23F8 Pause' : '\u25B6 Play';
      pb.style.background = isBad?'#C0392B':'#1A6B3C';
      document.getElementById('tabBad').style.background = mode==='bad'?'#FEF2F2':'#f5f5f5';
      document.getElementById('tabBad').style.color = mode==='bad'?'#9B1C1C':'#6B6B7B';
      document.getElementById('tabBad').style.borderBottom = mode==='bad'?'3px solid #C0392B':'3px solid transparent';
      document.getElementById('tabGood').style.background = mode==='good'?'#F0FDF4':'#f5f5f5';
      document.getElementById('tabGood').style.color = mode==='good'?'#14532D':'#6B6B7B';
      document.getElementById('tabGood').style.borderBottom = mode==='good'?'3px solid #1A6B3C':'3px solid transparent';
    }

    window.switchJourneyMode = function(m){
      mode=m; step=0; capsuleProg=0;
      if(playing){ clearInterval(playTimer); playing=false; }
      updateInfoPanel();
    };
    window.toggleJourneyPlay = function(){
      playing=!playing;
      if(playing){ playTimer=setInterval(function(){ step=(step+1)%4; updateInfoPanel(); },2600); }
      else { clearInterval(playTimer); }
      updateInfoPanel();
    };
    window.journeyStepNext = function(){ step=(step+1)%4; updateInfoPanel(); };

    updateInfoPanel();
    render();
  })();

  /* ═══════════════════════════════════════════
     STICKY HEADER
  ═══════════════════════════════════════════ */

  var stickyHeader = document.getElementById('stickyHeader');
  var heroSection = funnel.querySelector('.hero');
  var lastScrollY = 0;
  var ticking = false;

  if (stickyHeader && heroSection) {
    new IntersectionObserver(function(entries) {
      stickyHeader.classList.toggle('visible', !entries[0].isIntersecting);
    }, {threshold:0.1}).observe(heroSection);
  }

  /* ═══════════════════════════════════════════
     SCROLL REVEAL
  ═══════════════════════════════════════════ */

  var revealObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if(e.isIntersecting) { e.target.classList.add('visible'); revealObserver.unobserve(e.target); }
    });
  }, {threshold:0.10, rootMargin:'0px 0px -40px 0px'});
  funnel.querySelectorAll('.reveal').forEach(function(el) { revealObserver.observe(el); });

  /* ═══════════════════════════════════════════
     FAQ ACCORDION
  ═══════════════════════════════════════════ */

  window.toggleFaq = function(btn) {
    var item = btn.parentElement;
    var isOpen = item.classList.contains('open');
    funnel.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
    if (!isOpen) item.classList.add('open');
  };

  /* ═══════════════════════════════════════════
     PRICING CARD SELECT
  ═══════════════════════════════════════════ */

  funnel.querySelectorAll('.pricing-card').forEach(function(card) {
    card.addEventListener('click', function() {
      funnel.querySelectorAll('.pricing-card').forEach(function(c) { c.classList.remove('active'); });
      card.classList.add('active');
    });
  });

  /* ═══════════════════════════════════════════
     NAV HIDE/SHOW ON SCROLL
  ═══════════════════════════════════════════ */

  window.addEventListener('scroll', function() {
    if(!ticking) {
      requestAnimationFrame(function() { lastScrollY = window.scrollY; ticking = false; });
      ticking = true;
    }
  }, {passive: true});

  /* ═══════════════════════════════════════════
     ANIMATE BAR CHART ON SCROLL
  ═══════════════════════════════════════════ */

  var barObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if(e.isIntersecting) {
        e.target.querySelectorAll('.adv05-bar-fill').forEach(function(bar) {
          var w = bar.style.width; bar.style.width = '0';
          setTimeout(function() { bar.style.width = w; }, 100);
        });
        barObserver.unobserve(e.target);
      }
    });
  }, {threshold: 0.3});
  funnel.querySelectorAll('.adv05').forEach(function(el) { barObserver.observe(el); });

});
